import axios from "axios";
import { useEffect, useState } from "react";
import { useBrandingContext } from "../../../../../components/BrandingContext";

export const useFetchData = () => {
  const [extraBedPrice, setExtraBedPrice] = useState(0);
  const [addonservices, setAddOnServices] = useState([]);
  const [branding, setBranding] = useState("");
  const { branding: ctxBranding } = useBrandingContext();
  const [childrenPolicy, setChildrenPolicy] = useState({});
  const [promotions, setPromotions] = useState([]);

  useEffect(() => {
    const fetchPromotions = async () => {
      try {
        const response = await axios.get("/api/promotions/getallpromotions");
        setPromotions(response.data);
      } catch (error) {
        console.error("Error fetching promotions:", error);
      }
    };

    fetchPromotions();
  }, []);

  useEffect(() => {
    const fetchAddOnServices = async () => {
      try {
        const addonServicesResponse = await axios.get(
          "/api/addonservices/getalladdonservices"
        );
        setAddOnServices(addonServicesResponse.data);
      } catch (error) {
        console.error("Error fetching add-on services:", error);
      }
    };

    fetchAddOnServices();
  }, []);

  useEffect(() => {
    const fetchExtraBedPrice = async () => {
      try {
        const extraBedPriceResponse = await axios.get("/api/extrabedprice/get");
        setExtraBedPrice(extraBedPriceResponse.data.price);
      } catch (error) {
        console.error("Error fetching extra bed price:", error);
      }
    };

    fetchExtraBedPrice();
  }, []);

  useEffect(() => {
    if (ctxBranding) {
      try {
        const prev = JSON.stringify(branding || {});
        const next = JSON.stringify(ctxBranding || {});
        if (prev !== next) setBranding(ctxBranding);
      } catch (err) {
        setBranding(ctxBranding);
      }
    }
  }, [ctxBranding]);

  // Fetch tenant-level children policy and merge into formData
  useEffect(() => {
    const fetchChildrenPolicy = async () => {
      try {
        const res = await axios.get("/api/childrenpolicy/get");
        if (res && res.status === 200 && res.data) {
          // Normalize and merge into formData; write into both childrenAgeRule and childrenRule for compatibility
          setChildrenPolicy(res.data);
        }
      } catch (err) {
        // ignore 404 (not found) and report others
        if (!(err.response && err.response.status === 404)) {
          console.error("Failed to load tenant children policy", err);
        }
      }
    };

    fetchChildrenPolicy();
  }, []);

  return {
    promotions,
    extraBedPrice,
    addonservices,
    branding,
    childrenPolicy,
  };
};
